import { ProductionOrder, SortingModes } from '@app:types';
import { ReducerContext } from '../types';
import { OrdersState } from './orders.state';

export enum OrderMutations {
  START_LOADING = 'set-loading',
  STOP_LOADING = 'unset-loading',
  SET_ORDERS = 'set-order',
  SET_SORTING = 'set-sorting',
}

const reducers: ReducerContext<OrdersState> = {
  [OrderMutations.START_LOADING]: function (state) {
    state.isLoading = true;
  },
  [OrderMutations.STOP_LOADING]: function (state) {
    state.isLoading = false;
  },
  [OrderMutations.SET_SORTING]: function (
    state,
    payload: {
      key: keyof OrdersState['sortedBy'];
      sortMode: SortingModes;
    },
  ) {
    if (!(payload.key in state.sortedBy)) return;
    state.sortedBy[payload.key] = payload.sortMode;
  },
  [OrderMutations.SET_ORDERS]: function (
    state,
    payload: {
      items: ProductionOrder[];
      page: number;
      limit: number;
      totalItems: number;
    },
  ) {
    state.items = payload.items;
    state.page = payload.page;
    state.limit = payload.limit;
    state.totalItems = payload.totalItems;
    state.lastUpdated = new Date().toISOString();
  },
};

export default reducers;
